import { Modal } from '@abb/common-ux';
import * as React from 'react';

interface IHelpTextProviderState {
  isShowingHelp: boolean;
}

/**
 * We're using a pattern known as "render props".  Rather than force some other component
 * to use our button/link/whatever, we allow caller to chose their own control and pass it
 * to us as a "render" prop like this (stripped down to just the essentials):
 * 
 * <HelpTextProvider render={(onClickHandler: any) => {
 *    return <Button onClick={onClickHandler} />;
 * }}/>
 *
 * This object will then render that control, but when it does that this object will attach
 * its own "onClickHandler()".  Thus, caller chooses the control, its style, etc., and this
 * class receives the click event to display caller's help content.
 * 
 * Note that modal content is expected to be a tree of React components or HTML code, all of which
 * will be rendered in the help dialog.
 */
export interface IHelpTextProviderProps {
  modalTitle: string;
  render: (onClickHandler: any) => {};
  modalContent: React.ReactNode;
}

export class HelpTextProvider extends React.Component<IHelpTextProviderProps, IHelpTextProviderState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isShowingHelp: false
    };
  }

  // tslint:disable-next-line:one-line
  render(){
    const closeButton = (
      <button type='button' className='btn btn-primary' onClick={this.onCloseModal}>
        <span aria-hidden='true'>Close</span>
      </button>
    );

    return(
      <React.Fragment>
        {this.props.render(this.onClickHandler)}
        <Modal isOpen={this.state.isShowingHelp} header={this.props.modalTitle} footer={closeButton}
          onClose={this.onCloseModal} modalClassName='styleGuideModal'>
          {this.props.modalContent}
         </Modal>
      </React.Fragment>
    );
  }

  onClickHandler = () => {
    this.setState({isShowingHelp: true});
  }

  onCloseModal = () => {
    this.setState({isShowingHelp: false});
  }
}
